/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type EventsDropDown_user$ref = any;
export type ShopWithCeoProfile_user$ref = any;
export type ShopWithCeoProfile_user = {
    readonly shoppingWithCeoUser: ({
        readonly userId: string | null;
        readonly firstName: string | null;
    }) | null;
    readonly " $fragmentRefs": EventsDropDown_user$ref;
    readonly " $refType": ShopWithCeoProfile_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "ShopWithCeoProfile_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "FragmentSpread",
            "name": "EventsDropDown_user",
            "args": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "shoppingWithCeoUser",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "userId",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "firstName",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'deceb65227aa3270dc805880feead9c6';
export default node;
